import { useEffect, useState } from "react";
import {
  ButtonArea,
  CenteredContent,
  CenteredObject,
  Error,
  MainWrapper,
  TextArea,
  TextPtag,
} from "../Signup/style";
import { InputDiv } from "../../reuseableComp.tsx/InputWithLogo";
import EmailIcon from "../../useIconpark/emailIcon";
import { Button } from "../../reuseableComp.tsx/Button";
import SecurityIcon from "../../useIconpark/security";
import { UserPath } from "./style";
import BackLink from "../../reuseable/BackLink";
import { useNavigate } from "react-router-dom";
import { io, Socket } from "socket.io-client";
import axios from "axios";
import { ProgressBar } from "react-loader-spinner";
import { FiEye, FiEyeOff } from "react-icons/fi";

const AuthUser = () => {
  const [sockets, setSockets] = useState<Socket<any, any> | null>(null);
  const [contine, setContinue] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [avatar, setAvatar] = useState("");
  const [username, setUsername] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const payload = {
    email: email,
    password: password,
  };

  const handleGetImage = async () => {
    setLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_BASE_ENDPOINT}/getimage/${email}`)
      .then((res: any) => {
        if (res.data.result.image || res.data.result.user) {
          setAvatar(res.data.result.image);
          setUsername(res.data.result.user);
          setLoading(false);
          setContinue(true);
        } else {
          setLoading(false);
          setContinue(true);
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
        if (err && err.response.status === 403) {
          setContinue(true);
          setTimeout(() => {
            setError("");
          }, 3000);
        } else if (err.response && err.response.status === 404) {
          setError(err.response.data.message);
          setTimeout(() => {
            setError("");
          }, 3000);
        } else {
          setTimeout(() => {
            setError("");
          }, 3000);
        }
      });
  };

  const storedToken = sessionStorage.getItem("token");
  const token = `Bearer ${storedToken}`;
  const Authorization = {
    Authorization: token,
    "Content-Type": "application/json",
  };

  const handleLogin = async () => {
    setLoading(true);

    axios
      .post(`${process.env.REACT_APP_API_BASE_ENDPOINT}/sign-in`, payload)
      .then((res: any) => {
        console.log(res.data);
        setLoading(false);
        const token = String(res.data.result.token);
        sessionStorage.setItem("token", token);
        const chatId = String(res.data.result.chatId);
        sessionStorage.setItem("chatId", chatId);

        const loginTime = new Date().getTime();
        sessionStorage.setItem("loginTime", String(loginTime));
        const countdownTime = loginTime + 3600000;
        sessionStorage.setItem("countdownTime", String(countdownTime));
        if (
          !res.data.result.emailVerfied ||
          res.data.result.emailVerfied === false
        ) {
          axios.post(
            `${process.env.REACT_APP_API_BASE_ENDPOINT}/resend`,
            {},
            {
              headers: Authorization,
            }
          );
          navigate("/verify");
        } else {
          navigate("/chat");
        }
      })
      .catch((err) => {
        setTimeout(() => {
          setLoading(false);
        }, 3000);
        if (err.response && err.response.status === 403) {
          setError(err.response.data.message);
          setTimeout(() => {
            setError("");
          }, 3000);
        } else {
          setError(err.response.data.message);
          setTimeout(() => {
            setError("");
          }, 3000);
        }
      });
  };

  const handleNavigateChat = () => {
    navigate("/chat");
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  return (
    <>
      <MainWrapper>
        <BackLink path="/" />
        <CenteredObject>
          <CenteredContent>
            <TextArea>
              {contine ? (
                <>
                  <h2>Enter your Password</h2>
                </>
              ) : (
                <>
                  <h2>Login with your Email Address.</h2>
                </>
              )}
            </TextArea>
            <TextPtag>
              {contine ? (
                <>
                  <p>Please Enter your Your Secret Password</p>
                </>
              ) : (
                <>
                  <p>Please Enter your Email Address to get started</p>
                </>
              )}
            </TextPtag>

            {contine ? (
              <>
                <UserPath>
                  <div>
                    <img
                      src={avatar || "/image/user101.png"}
                      alt={username || "Unknown User"}
                    />
                  </div>
                  <div>
                    <p>Welcome</p>
                    <span>{username || "Unknown User"}</span>
                  </div>
                </UserPath>
              </>
            ) : (
              <>
                <InputDiv>
                  <div>
                    <EmailIcon size={45} trigger="loop" delay={2000} />
                  </div>
                  <div>
                    <input
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </InputDiv>
              </>
            )}

            {contine && (
              <>
                <InputDiv>
                  <div>
                    <SecurityIcon size={45} trigger="loop" delay={2000} />
                  </div>
                  <div>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter Password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <button type="button" onClick={togglePasswordVisibility}>
                      {showPassword ? (
                        <FiEyeOff color="#000" />
                      ) : (
                        <FiEye color="#000" />
                      )}
                    </button>
                  </div>
                </InputDiv>
              </>
            )}

            {error && (
              <>
                <Error>
                  <p>{error}</p>
                </Error>
              </>
            )}

            <ButtonArea>
              {contine ? (
                <>
                  <Button disabled={!password} onClick={handleLogin}>
                    {loading ? (
                      <>
                        <ProgressBar
                          height="60"
                          width="60"
                          ariaLabel="progress-bar-loading"
                          wrapperStyle={{}}
                          wrapperClass="progress-bar-wrapper"
                          borderColor="#F4442E"
                          barColor="#ffffff"
                        />
                      </>
                    ) : (
                      <>Sign In</>
                    )}
                  </Button>
                </>
              ) : (
                <>
                  <Button disabled={!email} onClick={handleGetImage}>
                    {loading ? (
                      <>
                        <ProgressBar
                          height="60"
                          width="60"
                          ariaLabel="progress-bar-loading"
                          wrapperStyle={{}}
                          wrapperClass="progress-bar-wrapper"
                          borderColor="#F4442E"
                          barColor="#ffffff"
                        />
                      </>
                    ) : (
                      <>Continue</>
                    )}
                  </Button>
                </>
              )}
            </ButtonArea>
          </CenteredContent>
        </CenteredObject>
      </MainWrapper>
    </>
  );
};

export default AuthUser;
